import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2907f5f2")

_pushScopeId("data-v-2907f5f2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传PDF")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")

  return (_openBlock(), _createBlock(_component_el_upload, {
    action: _ctx.fileUploadPath,
    headers: _ctx.tokenHeader,
    "on-success": _ctx.handleUploaded,
    "on-error": _ctx.handleUploadError,
    "before-upload": _ctx.beforeUpload,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel'))),
    "show-file-list": false,
    accept: "application/pdf"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_button, {
        loading: _ctx.showUploading,
        type: "primary",
        class: "font-20 margin-left-10 margin-right-10",
        icon: "el-icon-circle-plus-outline"
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["action", "headers", "on-success", "on-error", "before-upload"]))
})